import { FC } from 'react'
import { StyleHeaderImageWrapper, StyleHeaderWrapper } from './style'
import Image from '@components/image'
import Typography from '@components/typography'
interface SupportMessageHeaderProps {
  receiver: any
}
const SupportMessageHeader: FC<SupportMessageHeaderProps> = ({ receiver }) => {
  return (
    <StyleHeaderWrapper>
      <StyleHeaderImageWrapper>
        <Image
          src="/"
          fallbackType="user"
          height={40}
          width={40}
          styleImage="border-radius:50%"
        />
        <Typography size={14} content={receiver?.name} />
      </StyleHeaderImageWrapper>
    </StyleHeaderWrapper>
  )
}

export default SupportMessageHeader
